import { render, staticRenderFns } from "./VideoInline.vue?vue&type=template&id=24f438a3&scoped=true"
import script from "./VideoInline.js?vue&type=script&lang=js&external"
export * from "./VideoInline.js?vue&type=script&lang=js&external"
import style0 from "./VideoInline.scss?vue&type=style&index=0&id=24f438a3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f438a3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotIcon: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Icon/Icon.vue').default,HotImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default})
